<adapt-display-accordion-hierarchy [hierarchy]="teamsHierarchy$ | async"></adapt-display-accordion-hierarchy>
